import { Section } from "../ui/Section";
import { Eyebrow } from "../ui/Eyebrow";
import { H2, Highlight } from "../ui/Heading";
import { ChatThread } from "../chat/ChatThread";
import { BUILD_MESSAGES, RECIPES } from "../data/automations";
import { RecipeCard } from "./RecipeCard";

const COLUMN_LABEL =
  "font-mono text-[11px] uppercase tracking-[0.18em] text-accent mb-3.5";

export function Automations() {
  return (
    <Section id="automations">
      <Eyebrow n="03">Automations</Eyebrow>
      <H2 className="max-w-[980px]">
        Build any automation <Highlight>you can describe</Highlight>.
      </H2>
      <p className="mt-4.5 max-w-[720px] text-lg text-td-2">
        Nothing comes "out of the box." Sidestack is the system; you tell it
        what to automate. Anything you'd ask an assistant to do, you can ask
        Sidestack to do — once, and it runs forever.
      </p>

      <div className="mt-14 grid grid-cols-2 gap-12 items-start max-md:grid-cols-1 max-md:gap-9">
        <div>
          <div className={COLUMN_LABEL}>Build one in plain English</div>
          <ChatThread messages={BUILD_MESSAGES} height={520} />
          <p className="mt-4.5 text-sm italic text-td-3">
            No flowcharts. No nodes. Just describe it. Sidestack figures out
            the wiring and shows you exactly what it'll do before you turn it
            on.
          </p>
        </div>
        <div>
          <div className={COLUMN_LABEL}>Recipes our customers run</div>
          <div className="flex flex-col gap-2.5">
            {RECIPES.map((recipe, i) => (
              <RecipeCard key={i} recipe={recipe} />
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
